import {  FC, useState, useEffect, useMemo } from "react"
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { TablesWidget10 } from "../../../smallnation/partials/widgets"
import { ErrorMessage } from "@hookform/error-message";
import { KTSVG } from "../../../smallnation/helpers";
import { Link } from 'react-router-dom';

//import { useForm } from "react-hookform";
import { useForm } from "react-hook-form";
import services from "../../modules/services/services";
//import $, { parseJSON } from 'jquery';
import $ from 'jquery';
import {  useLocation, useHistory } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import UsNumberValidate from "../../modules/utility/usNumberValidate";
//import ImageUploader from "react-images-upload";

const EditCompanyUsersList: FC = () => {
  const intl = useIntl();
  let history = useHistory();
  const [categories, setCategory] = useState([]);
  const [locationCounty, setLocationCounty] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [companyProf, setCompanyProfile] = useState([]);
  const [companyinfo, setCompanyInfo] = useState([]);
  const [companyDisplayName, setCompanyDisplayName] = useState([]);
  const red = "red";
  var companytitle_name;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const companyId = queryParams.get('companyId');
  const [userList, setUsersList] = useState([]);

  const [fileName, setFileName] = useState('');
  const [fileExtension, setFileExtension] = useState('');
  const [fileBase64, setFileBase64] = useState('');
  var companylogofile = '';
  const [logourlDisplay, setLogoUrlDisplay] = useState('');
  var filename_logo = '';
  var fileext_logo = '';
  var filebase_logo = '';


  const [bannerName, setBannerName] = useState('');
  const [bannerExtension, setBannerExtension] = useState('');
  const [bannerBase64, setBannerBase64] = useState('');
  var companybannerfile = '';
  const [bannerurlDisplay, setBannerUrlDisplay] = useState('');
  var filename_banner = '';
  var fileext_banner = '';
  var filebase_banner = '';

  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    criteriaMode: "all", mode: "onBlur"
  });



  function validateCheck() {
    //alert("test");
  }
  function getDisplayRole(rolev) {
    if (rolev == "employerUser") {
      return "Company User";
    } else if (rolev == "employerAdmin") {
      return "Company Admin";
    }
    return "";
  }

  function getDisplayStatus(st) {
    if (st == "active") {
      return "Active";
    } else if (st == "inactive") {
      return "Inactive";
    } else if (st == "pending") {
      return "Active";
    }
    return "";
  }

  function getCompanyInfo(companyId) {
    services.adminGetCompanyProfile(companyId).then((res) => {
      if (res.data) {
        setCompanyInfo(res.data);
        var companyProfile = res.data;
        /* {
                 "schoolId": null,
           "firstName": null,       "lastName": null,       "password": null,    "isStudent": null,
           "countyName": "ohio",   "email": "pipamycu@mailinator.com",  "bannerUrl": null,      "logoUrl": "",   "videoUrl": "",   "userType": null,   "hasAccessToJobPosting": "yes",
           "updatedOn": "2022-04-24T06:52:58.286+00:00",   "longitude": null,   "latitude": null,    "securityRoleId": null,   "securityRoleName": null,           "perksList": []
       } */
        var statustxt = "";
        if (companyProfile.status == "published" || companyProfile.status == "Published") {
          statustxt = "Published";
        }
        if (companyProfile.status == "pending" || companyProfile.status == "Pending") {
          statustxt = "Pending";
        }

        companylogofile = companyProfile.logoUrl;
        setLogoUrlDisplay(companyProfile.logoUrl);
        setBannerUrlDisplay(companyProfile.bannerUrl);
        setTimeout(() => {
          console.log("Delayed for 1 second.");
          $('#approval_status').val(statustxt);
          $('#first_name').val(companyProfile.firstName);
          $('#last_name').val(companyProfile.lastName);
          $('#public_profile').val(companyProfile.publicProfile);
          $('#view_resumes').val(companyProfile.hasAccessToResume);
          $('#company_name').val(companyProfile.name);
          var ecpname:any = "Edit Company - " + companyProfile.name;
          setCompanyDisplayName(ecpname);
          //setCompanyDisplayName("Edit Company - " + companyProfile.name)
          $('#email_id').val(companyProfile.email);
          $('#address_1').val(companyProfile.address1);
          $('#address_2').val(companyProfile.address2);
          $('#city').val(companyProfile.city);
          $('#state').val(companyProfile.state);
          $('#postalcode').val(companyProfile.zip);

          $('#country').val(companyProfile.countyId);
          $('#phone_number').val(companyProfile.phone);
          $('#noofemp').val(companyProfile.employeeCount);
          $('#websiteurl').val(companyProfile.webSite);
          $("#hasAccessToJobPosting").val(companyProfile.hasAccessToJobPosting);
          //$("#view_resumes").val(companyProfile.hasAccessToResume);
          $('#view_resumes option[value=' + companyProfile.hasAccessToResume + ']').attr('selected', 'selected');

          var catarray = companyProfile.companyCategory;
          console.log(catarray);
          for (var i = 0; i < catarray.length; i++) {
            //alert(catarray[i]);
            //$('#'+catarray[i]+'').prop('checked', true);
            // $('#'+catarray[i]+'').trigger("click");
            // $('input[name="procategory"][value="' + catarray[i] + '"]').trigger("click");
            $('input[name="procategory"][value="' + catarray[i] + '"]').prop('checked', true);
            $('input[name="procategory"][value="' + catarray[i] + '"]').attr('checked', "true");
          }
          for (var i = 0; i < catarray.length; i++) {
            $('#' + catarray[i]).prop('checked', true);
          }

        }, 1500)




      }

    });
  };



  function filterUserList(companyId) {

    const requestObject = {

      "siteId": "2",
      "userType": "company",
      "searchTxt": "",
      "companyId": companyId,
      "pageNumber": 1,
      "pageSize": 150
    }
    console.log(requestObject);
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
         'Authorization': "Bearer "+accessTokenIn
        //'Authorization': accessTokenIn
      },
      body: JSON.stringify(requestObject)
    };

    services.getAdminUserList(requestOptions).then((res) => {
      console.log("#######################");
      console.log(res);
      if (res) {
        // console.log(JSON.stringify(res));
        try {
          setUsersList(res.content);
        } catch (ex) {
          console.log("ex:" + ex);
        }

      }
      else {
        setUsersList([]);
      }


    });
  }

  function getImage() {
    //var files = document.getElementById('company_logo_new').files;
    var files:any = (document.getElementById("company_logo_new") as HTMLInputElement | null)?.files;
    if (files.length > 0) {

      var fname = files[0].name;
      // var fextn = fname.substr(0, fname.lastIndexOf('.'));
      var fextn = fname.split(".").pop();
      // alert(fextn);
      var fileActName = fname.split(".")[0];

      setFileName(fileActName);
      filename_logo = fileActName;
      setFileExtension(fextn);
      fileext_logo = fextn;
      getBase64(files[0]);
      //alert(fileActName);
      if (fextn != "png" && fextn != "jpeg" && fextn != "jpg" && fextn != "gif") {

        $("#fileError").show();
        return false;
      } else {
        $("#fileError").hide();
        setTimeout(() => {
          updateCompanyLogo();
        }, 1000)

      }

    }
  }
  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      // console.log(reader.result);
      var rdt:any = reader.result;
      var base64result = rdt.split(',')[1];
      //var base64result = reader.result.split(',')[1];
      filebase_logo = base64result;
      setFileBase64(base64result)
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  function updateCompanyLogo() {
    //alert(filename_logo);
    //alert(fileext_logo);
    //alert(filebase_logo);
    const requestObject = {
      "logoName": filename_logo,
      "companyId": companyId,
      "logoExtension": fileext_logo,
      "logoByteString": filebase_logo
    }
    console.log(requestObject);
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + accessTokenIn
        //'Authorization': accessTokenIn
      },
      body: JSON.stringify(requestObject)
    };

    services.admineditCompanyLogo(requestOptions).then((res) => {
      console.log(res);
      getCompanyInfo(companyId);
    });
  }

  function getBannerImage() {
    //var banner = document.getElementById('company_banner_new').files;
    var banner:any = (document.getElementById("company_banner_new") as HTMLInputElement | null)?.files;
    if (banner.length > 0) {

      var bname = banner[0].name;
      var bextn = bname.split(".").pop();
      // alert(fextn);
      var bannerActName = bname.split(".")[0];

      setBannerName(bannerActName);
      filename_banner = bannerActName;
      setBannerExtension(bextn);
      fileext_banner = bextn;
      getBase64_banner(banner[0]);
      //alert(fileActName);
      if (bextn != "png" && bextn != "jpeg" && bextn != "jpg" && bextn != "gif") {

        $("#bannerError").show();
        return false;
      } else {
        $("#bannerError").hide();
        setTimeout(() => {
          updateCompanyBanner();
        }, 1000)

      }

    }
  }

  function getBase64_banner(file) {
    var reader1 = new FileReader();
    reader1.readAsDataURL(file);
    reader1.onload = function () {
      // console.log(reader.result);
      var rdt1:any = reader1.result;
      var base64result_banner = rdt1.split(',')[1];
      //var base64result_banner = reader1.result.split(',')[1];
      filebase_banner = base64result_banner;
      setBannerBase64(base64result_banner)
    };
    reader1.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  function updateCompanyBanner() {
    //alert(filename_banner);
    //alert(fileext_banner);
    //alert(filebase_banner);
    const requestObject = {
      "imageName": filename_banner,
      "companyId": companyId,
      "imageExtension": fileext_banner,
      "imageByteString": filebase_banner
    }
    console.log(requestObject);
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + accessTokenIn
        //'Authorization': accessTokenIn
      },
      body: JSON.stringify(requestObject)
    };

    services.admineditCompanyBanner(requestOptions).then((res) => {
      console.log(res);
      getCompanyInfo(companyId);
    });
  }

  useEffect(() => {

    validateCheck();
    //getCompanyInfo(companyId);
    filterUserList(companyId);
    //$('#phone_number').usPhoneFormat();
    ($('#phone_number') as any).usPhoneFormat();
    $("#companyProfileValidMsg").hide();
    $("#companynameValidMsg").hide();
    $("#companystatusValidMsg").hide();
    $("#addressValidMsg").hide();
    $("#cityValidMsg").hide();
    $("#stateValidMsg").hide();
    $("#postalcodeValidMsg").hide();
    $("#countryValidMsg").hide();
    $("#employeesValidMsg").hide();
    $("#fileError").hide();
    $("#bannerError").hide();
    $("#categoryValidMsg").hide();


    var statesJson = [{ "stateId": 4, "stateName": "Alabama", "stateCode": "AL" }, { "stateId": 5, "stateName": "Alaska", "stateCode": "AK" }, { "stateId": 6, "stateName": "Alabama", "stateCode": "AL" }, { "stateId": 7, "stateName": "Arizona", "stateCode": "AZ" }, { "stateId": 8, "stateName": "Arkansas", "stateCode": "AR" }, { "stateId": 9, "stateName": "California", "stateCode": "CA" }, { "stateId": 10, "stateName": "Colorado", "stateCode": "CO" }, { "stateId": 11, "stateName": "Connecticut", "stateCode": "CT" }, { "stateId": 12, "stateName": "Delaware", "stateCode": "DE" }, { "stateId": 13, "stateName": "District of Columbia", "stateCode": "DC" }, { "stateId": 14, "stateName": "Florida", "stateCode": "FL" }, { "stateId": 15, "stateName": "Georgia", "stateCode": "GA" }, { "stateId": 16, "stateName": "Hawaii", "stateCode": "HI" }, { "stateId": 17, "stateName": "Idaho", "stateCode": "ID" }, { "stateId": 18, "stateName": "Illinois", "stateCode": "IL" }, { "stateId": 19, "stateName": "Indiana", "stateCode": "IN" }, { "stateId": 20, "stateName": "Iowa", "stateCode": "IA" }, { "stateId": 21, "stateName": "Kansas", "stateCode": "KS" }, { "stateId": 22, "stateName": "Kentucky", "stateCode": "KY" }, { "stateId": 23, "stateName": "Louisiana", "stateCode": "LA" }, { "stateId": 24, "stateName": "Maine", "stateCode": "ME" }, { "stateId": 25, "stateName": "Maryland", "stateCode": "MD" }, { "stateId": 26, "stateName": "Massachusetts", "stateCode": "MA" }, { "stateId": 27, "stateName": "Michigan", "stateCode": "MI" }, { "stateId": 28, "stateName": "Minnesota", "stateCode": "MN" }, { "stateId": 29, "stateName": "Mississippi", "stateCode": "MS" }, { "stateId": 30, "stateName": "Missouri", "stateCode": "MO" }, { "stateId": 31, "stateName": "Montana", "stateCode": "MT" }, { "stateId": 32, "stateName": "Nebraska", "stateCode": "NE" }, { "stateId": 33, "stateName": "Nevada", "stateCode": "NV" }, { "stateId": 34, "stateName": "New Hampshire", "stateCode": "NH" }, { "stateId": 35, "stateName": "New Jersey", "stateCode": "NJ" }, { "stateId": 36, "stateName": "New Mexico", "stateCode": "NM" }, { "stateId": 37, "stateName": "New York", "stateCode": "NY" }, { "stateId": 38, "stateName": "North Carolina", "stateCode": "NC" }, { "stateId": 39, "stateName": "North Dakota", "stateCode": "ND" }, { "stateId": 40, "stateName": "Ohio", "stateCode": "OH" }, { "stateId": 41, "stateName": "Oklahoma", "stateCode": "OK" }, { "stateId": 42, "stateName": "Oregon", "stateCode": "OR" }, { "stateId": 43, "stateName": "Pennsylvania", "stateCode": "PA" }, { "stateId": 44, "stateName": "Puerto Rico", "stateCode": "PR" }, { "stateId": 45, "stateName": "Rhode Island", "stateCode": "RI" }, { "stateId": 46, "stateName": "South Carolina", "stateCode": "SC" }, { "stateId": 47, "stateName": "South Dakota", "stateCode": "SD" }, { "stateId": 48, "stateName": "Tennessee", "stateCode": "TN" }, { "stateId": 49, "stateName": "Texas", "stateCode": "TX" }, { "stateId": 50, "stateName": "Utah", "stateCode": "UT" }, { "stateId": 51, "stateName": "Vermont", "stateCode": "VT" }, { "stateId": 52, "stateName": "Virginia", "stateCode": "VA" }, { "stateId": 53, "stateName": "Washington", "stateCode": "WA" }, { "stateId": 54, "stateName": "West Virginia", "stateCode": "WV" }, { "stateId": 55, "stateName": "Wisconsin", "stateCode": "WI" }, { "stateId": 56, "stateName": "Wyoming", "stateCode": "WY" }];
    setStateData(statesJson);

  }, []);

  return (
    <>
      <PageTitle breadcrumbs={[]}>{companyDisplayName}</PageTitle>
      <form >
        <div className="container px-0">


          <div id="companyUsersDiv">
            <h3 className="mb-7">Company Users</h3>
            {/* begin::Table */}
            <div className="card mt-5">
            <div className="card-body">


            <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
              {/* begin::Table head */}
              <thead>
                <tr className='fw-bolder text-muted'>

                  <th className='min-w-150px'>Name</th>
                  <th className='min-w-140px'>Email</th>
                  {/* <th className='min-w-120px'>Phone</th>             */}
                  <th className='min-w-120px'>User Role</th>
                  <th className='min-w-120px'>Status</th>

                  <th className='min-w-100px text-end'>Actions</th>
                </tr>
              </thead>
              {/* end::Table head */}
              {/* begin::Table body */}
              <tbody>

                {
                  userList.map((data, index) => (
                    <tr>

                      <td>
                        <Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={`/editcompanyuser?userId=` + data.userId + `&companyId=` + data.companyId+`&tab=2`}> {(data.firstName=='' || data.firstName==null) ? '--' : data.firstName+' '+data.lastName}</Link>
                      </td>
                      <td>

                        <Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={`/editcompanyuser?userId=` + data.userId + `&companyId=` + data.companyId+`&tab=2`}> {(data.email=='' || data.email==null) ? '--' : data.email}</Link>

                      </td>

                      <td>
                        <Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={`/editcompanyuser?userId=` + data.userId + `&companyId=` + data.companyId+`&tab=2`}>{(data.roleName=='' || data.roleName==null) ? '--' : getDisplayRole(data.roleName)}</Link>
                      </td>

                      <td>
                        <Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={`/editcompanyuser?userId=` + data.userId + `&companyId=` + data.companyId+`&tab=2`}>{(data.status=='' || data.status==null) ? '--' : getDisplayStatus(data.status)}</Link>
                      </td>


                      <td className='text-end'>

                        {/* <a
                    href="#"
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                  >
                    <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                  </a> */}

                        <Link className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1' to={`/editcompanyuser?userId=` + data.userId + `&companyId=` + data.companyId+`&tab=2`}>  <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' /></Link>

                      </td>
                    </tr>
                  ))}



              </tbody>
              {/* end::Table body */}
            </table>

            </div>
            </div>

            <div>
              <Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={`/addcompanyuser?companyId=` + companyId+`&tab=2`}>  <button className="btn btn-primary mt-10" style={{ maxWidth: "200px" }}> + Add New User </button></Link>
            </div>
          </div>

        </div>
      </form>
    </>
  )
}
export { EditCompanyUsersList }